import {merge} from '#core/utils/config-utils.js';
import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateBetBuilderSelectionItem} from '#core/application/modules/tiles/bet-builder-selection-item/index.js';
import {generateNeutralVenueIndicator} from '#core/application/modules/tiles/neutral-venue-indicator/index.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generatePriceBoostBanner} from '#core/application/modules/tiles/price-boost-banner/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';
import {generateSecondaryLink} from '#core/application/modules/tiles/link/index.js';

export function preBuiltCardsFactory(PALETTE) {
    const SHOW_ALL_SELECTIONS_BUTTON = {
        button: merge(generateSecondaryLink(PALETTE.PREBUILT_CARD_SHOW_MORE_BUTTON), {
            style: {
                base: {
                    alignItems: 'center',
                },
            },
        }),
        buttonLabel: {
            style: {
                ...PALETTE.PREBUILT_CARD_SHOW_MORE_BUTTON.SECONDARY_LINK_TEXT,
            },
        },
        buttonIcon: icon(PALETTE.PREBUILT_CARD_SHOW_MORE_BUTTON.SECONDARY_LINK_ICON_COLOR),
    };

    return {
        PrebuiltBetController: {
            prebuiltBetBuilder: {
                view: {
                    showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
                },
            },
            prebuiltAcca: {
                view: {
                    showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
                },
            },
        },
        PrebuiltBet: {
            genericEventCard: {
                container: {
                    itemSpacing: 8,
                    style: {
                        ...resolveBackground(PALETTE.PREBUILT_CARD_CONTAINER_BG),
                        ...generateBorder(PALETTE.PREBUILT_CARD_BORDER),
                    },
                },
            },
            matchAccaSelectionsContainer: {
                style: {
                    flexGrow: 0,
                },
            },
            matchAccaSelectionItem: merge(generateBetBuilderSelectionItem(PALETTE.CARD_MATCH_ACCA_SELECTION_ITEM), {
                marketInfoContainer: {
                    style: {
                        padding: 0,
                    },
                },
                marketName: {
                    style: PALETTE.CARD_MATCH_ACCA_SELECTION_MARKET_NAME_TEXT,
                },
                selectionLabel: {
                    style: {
                        overflowWrap: 'anywhere',
                    },
                },
            }),
            selectionContentContainer: {
                style: {
                    padding: '0 8px 8px',
                },
            },
            selectionButton: generateOddsButton(PALETTE.PREBUILT_CARD_ODDS_BUTTON),
            priceBoostBanner: generatePriceBoostBanner(PALETTE.CARD_PREBUILT_PRICE_BOOST_BANNER),
            showAllSelectionsButton: {
                showAllButton: SHOW_ALL_SELECTIONS_BUTTON,
                hideAllButton: SHOW_ALL_SELECTIONS_BUTTON,
            },
        },
        PrebuiltBetBuilder: {
            headerContainer: {
                style: {
                    flexGrow: 0,
                },
            },
            participantsIconInline: {
                participantName: {
                    style: PALETTE.CARD_MATCH_ACCA_EVENT_NAME_TEXT,
                },
                separator: {
                    style: PALETTE.CARD_MATCH_ACCA_EVENT_NAME_TEXT,
                },
            },
            promotionText: {
                style: {
                    ...PALETTE.CARD_MATCH_ACCA_EVENT_NAME_TEXT,
                },
            },
            startTime: {
                style: PALETTE.CARD_MATCH_ACCA_EVENT_INFO_TEXT,
            },
            matchAccaIcon: merge(icon(PALETTE.CARD_MATCH_ACCA_BB_BET_ICON_COLOR, 'system-betbuilder'), {
                style: {
                    width: 28,
                    height: 28,
                },
            }),
            typeName: {
                style: PALETTE.CARD_MATCH_ACCA_EVENT_INFO_TEXT,
            },
            neutralVenueIndicator: generateNeutralVenueIndicator(PALETTE.CARD_MATCH_ACCA_BB_NEUTRAL_VENUE_INDICATOR),
        },
        PrebuiltAcca: {
            view: {
                matchAccaSelectionItem: {
                    marketName: {
                        style: PALETTE.CARD_PREBUILT_ACCA_SELECTION_BB_BET_MARKET_TEXT,
                    },
                    eventName: {
                        style: PALETTE.CARD_PREBUILT_ACCA_SELECTION_BB_BET_EVENT_TEXT,
                    },
                },
            },
            headerContainer: {
                style: {
                    flexGrow: 0,
                },
            },
            promotionText: {
                style: {
                    ...PALETTE.CARD_MATCH_ACCA_EVENT_NAME_TEXT,
                },
            },
            marketName: {
                style: {
                    ...PALETTE.CARD_MATCH_ACCA_EVENT_INFO_TEXT,
                },
            },
        },
        PrebuiltBetsSkeleton: {
            container: {
                style: {
                    padding: '0 0 2px 0',
                    _mobile_padding: '0 8px 2px 0',
                },
            },
            cardContainer: {
                style: {
                    ...resolveBackground(PALETTE.PREBUILT_CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.PREBUILT_CARD_BORDER),
                },
            },
        },
    };
}
